// extracted by mini-css-extract-plugin
export default {"body_container":"create-new-password-with-validation_body_container__uoemd","checkboxes":"create-new-password-with-validation_checkboxes__GeDwa"};